import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { AxiosErrorHandler } from './common/AxiosErrorHandler';
import CustomSnackbar from './components/common/CustomSnackbar';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <CustomSnackbar />
    <AxiosErrorHandler>
      <App />
    </AxiosErrorHandler>
  </BrowserRouter>,
);
